module.exports = {
  "messages": {
    "A11Y_LOGO": "Zur XING Startseite",
    "A11Y_SETTINGS_DROPDOWN_LABEL": "Einstellungen verwalten",
    "ACTION_BLOCK_USER": "Blockieren",
    "ACTION_BLOCK_USER_DIALOG_DESCRIPTION": "Wenn Du {displayName} blockierst, kann Dich dieses Mitglied nicht mehr auf XING kontaktieren.",
    "ACTION_BLOCK_USER_DIALOG_TITLE": "Möchtest Du Dein Profil für dieses Mitglied blockieren?",
    "ACTION_BLOCK_USER_SUCCESS": "Mitglied blockiert",
    "ACTIVE_LANGUAGE": "Deutsch",
    "ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT": "Austausch",
    "BREWERY_NOCOOKIES_LINK_TARGET": "https://faq.xing.com/de/sicherheit/was-sind-cookies-und-warum-brauche-ich-sie-beim-einloggen",
    "BREWERY_NOCOOKIES_LINK_TEXT": "Cookies aktivieren",
    "BREWERY_NOCOOKIES_PARAGRAPH": "Denn nur mit aktivierten Cookies funktioniert das Einloggen. Hier erfährst Du, wie's geht: ",
    "BREWERY_NOCOOKIES_TITLE": "Bitte aktiviere die Cookies.",
    "BREWERY_NOJAVASCRIPT_LINK_TARGET": "https://faq.xing.com/de/einstellungen/javascript-meinem-browser-aktivieren",
    "BREWERY_NOJAVASCRIPT_LINK_TEXT": "JavaScript aktivieren",
    "BREWERY_NOJAVASCRIPT_PARAGRAPH": "Aktivier bitte JavaScript, denn nur so siehst Du alle unsere Inhalte. Hier erfährst Du, wie's geht:",
    "BREWERY_NOJAVASCRIPT_TITLE": "Bitte aktiviere JavaScript.",
    "BUTTON_BACK": "Zurück",
    "BUTTON_CANCEL": "Abbrechen",
    "BUTTON_CLOSE": "Schließen",
    "BUTTON_CLOSEWINDOW": "Fenster schließen",
    "BUTTON_CONTINUE": "OK",
    "BUTTON_FORWARD": "Weiter",
    "CAL_DATE_FORMAT": "DD.MM.YYYY",
    "CAL_DATE_FORMAT_HINT": "TT.MM.JJJJ",
    "CB_POSTING_ERROR": "Das hat leider nicht geklappt. Bitte versuch es noch einmal.",
    "COMMBOX_ACTOR_SWITCH_CANCEL": "Absender beibehalten",
    "COMMBOX_ACTOR_SWITCH_CONFIRM": "Absender ändern",
    "COMMBOX_ACTOR_SWITCH_HEADLINE": "Wer soll der Absender dieses Beitrags sein?",
    "COMMBOX_ACTOR_SWITCH_HINT": "Um den Absender dieses Beitrags zu ändern, tipp einfach oben auf den Namen.",
    "COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE": "Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Bild geht dabei verloren.",
    "COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO": "Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Video geht dabei verloren.",
    "COMMBOX_ACTOR_SWITCH_TYPE_PAGE": "Eine Seite",
    "COMMBOX_ACTOR_SWITCH_TYPE_USER": "Eine Person",
    "COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER": "1 Bild kannst Du noch hinzufügen.",
    "COMMBOX_AUDIENCE_CITY_CONTACTS": "Nur Kontakte in meinem Arbeitsort ({totalCount})",
    "COMMBOX_AUDIENCE_FOLLOWERS": "Nur Follower",
    "COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS": "Follower & Kontakte",
    "COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC": "Dein Beitrag kann geteilt werden.",
    "COMMBOX_AUDIENCE_FOLLOWERS_DESC": "Dein Beitrag kann geteilt werden.",
    "COMMBOX_AUDIENCE_HEADLINE": "Wer darf das sehen?",
    "COMMBOX_AUDIENCE_PRIVATE": "Privat (nur XING Kontakte)",
    "COMMBOX_AUDIENCE_PRIVATE_DESC": "Dein Beitrag kann nicht geteilt werden.",
    "COMMBOX_AUDIENCE_PRIVATE_SELECTED": "Privat",
    "COMMBOX_AUDIENCE_PUBLIC": "Öffentlich",
    "COMMBOX_AUDIENCE_PUBLIC_DESC": "Jeder kann Deinen Beitrag sehen und teilen.",
    "COMMBOX_BUTTON_ADD_VIDEO_LABEL": "Video hinzufügen",
    "COMMBOX_BUTTON_OPEN_FILES_LABEL": "Dokument hinzufügen",
    "COMMBOX_BUTTON_OPEN_POLL_LABEL": "Umfrage starten",
    "COMMBOX_CANCEL_POSTING_BUTTON_BACK": "Weiter bearbeiten",
    "COMMBOX_CANCEL_POSTING_BUTTON_CANCEL": "Beitrag verwerfen",
    "COMMBOX_CANCEL_POSTING_HEADLINE": "Möchtest Du den Beitrag verwerfen?",
    "COMMBOX_CANCEL_POSTING_TEXT_MESSAGE": "Deine Eingaben gehen dann verloren.",
    "COMMBOX_CHARACTERS_LEFT": "übrig",
    "COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT": "Bilder auswählen",
    "COMMBOX_EMPTY_DROPZONE_TEXT": "JPG, BMG oder PNG (max. {max_size} MB pro Bild)",
    "COMMBOX_EMPTY_DROPZONE_TITLE": "Du kannst bis zu {max_images} Bilder hierher ziehen oder auswählen.",
    "COMMBOX_EMPTY_TEXT_FIELD": "Teil ein Foto, einen Link oder schreib was …",
    "COMMBOX_EMPTY_TEXT_FIELD_MENTIONS": "Teil ein Foto, einen Link oder einen Gedanken (mit \"@\" andere erwähnen) ...",
    "COMMBOX_ENTRY_POINT_LABEL": "Eingabefeld für Deinen Beitrag",
    "COMMBOX_ENTRY_POINT_TEXT": "Was gibt’s Neues?",
    "COMMBOX_FILLED_DROPZONE_HEADER": "{pictures} Bilder kannst Du noch hinzufügen.",
    "COMMBOX_FULL_FILLED_DROPZONE_HEADER": "Du hast jetzt die maximale Anzahl an Fotos hinzugefügt.",
    "COMMBOX_IMAGE_BUTTON_LABEL": "Bild hinzufügen",
    "COMMBOX_IMAGE_SIZE_UPLOAD_ERROR": "Bitte wähle ein Bild, das max. 10 MB groß ist.",
    "COMMBOX_IMAGE_TYPE_UPLOAD_ERROR": "Bitte wähle ein Bild im JPG- oder PNG-Format.",
    "COMMBOX_POST": "Teilen",
    "COMMBOX_SUCCESS_ACTION": "Beitrag ansehen",
    "COMMBOX_SUCCESS_DESC": "Dein Beitrag wurde auf XING geteilt.",
    "COMMBOX_SUCCESS_HEADLINE": "Und fertig!",
    "COMMBOX_SUCCESS_SCHEDULED_DESC": "Dein Beitrag wird am {date} um {time} Uhr geteilt.",
    "COMMBOX_UPDATE_BTN": "Speichern",
    "COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED": "Du hast schon 10 Bilder hinzugefügt – mehr geht leider nicht.",
    "COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE": "Das Video wird gerade vorbereitet ... einen Moment Geduld bitte.",
    "COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR": "Das hat leider nicht geklappt – einfach gleich nochmal versuchen!",
    "COMMBOX_VIEW_POST_BTN": "Beitrag ansehen",
    "COMMENT_BUTTON_LABEL": "Kommentieren",
    "CONTENT_ERROR_404_BUTTON": "Zur XING Startseite",
    "CONTENT_ERROR_404_HEADLINE": "Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.",
    "CONTENT_ERROR_404_SUBLINE": "Aber hier gibt's garantiert etwas zu entdecken:",
    "CONTENT_ERROR_503_HEADLINE": "Sieht so aus, als hätten wir gerade ein kleines Problem.",
    "CONTENT_ERROR_503_SUBLINE": "Bitte hab einen Moment Geduld. Wir arbeiten daran.",
    "CONTENT_ERROR_OFFLINE": "Bitte prüfe Deine Internet-Verbindung. Versuch's dann einfach noch einmal.",
    "CONTENT_FOLLOW": "Folgen",
    "CONTENT_FOLLOWED": "Folgst Du",
    "CONTENT_SWITCHER_MORE": "Mehr",
    "CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG": "{minutesCount, plural,\n   =1 {Eben gerade}\n   other {Vor # Minuten}\n}",
    "CONTENT_TIMESTAMP_AN_HOUR_AGO_SHORT": "{minutesCount, plural,\n   =1 {Jetzt}\n   other {# Min.}\n}",
    "CONTENT_TIMESTAMP_DAYS": "Tage",
    "CONTENT_TIMESTAMP_DAYS_AGO_LONG": "{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {Vor # Tagen}\n}",
    "CONTENT_TIMESTAMP_DAYS_AGO_SHORT": "{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {# Tage}\n}",
    "CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO": "Gerade eben",
    "CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG": "{hoursCount, plural,\n   =1 {Vor 1 Stunde}\n   other {Vor # Stunden}\n}",
    "CONTENT_TIMESTAMP_SOME_HOUR_AGO_SHORT": "{hoursCount, plural,\n   =1 {1 Std.}\n   other {# Std.}\n}",
    "CONTENT_TIMESTAMP_TODAY": "Heute",
    "CONTENT_UNFOLLOW": "Nicht mehr folgen",
    "CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER": "Geben Sie hier den Titel Ihres Videos ein.",
    "CONTENT_VIDEO_RECOS_REASON": "Beliebte Videos auf XING",
    "CROSSPOST_SHARE_ERROR": "Bitte nicht übertreiben. Du hast den Beitrag schon in 3 Gruppen geteilt.",
    "DAY_NAMES": "Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag,Sonntag",
    "DAY_NAMES_SHORT": "Mo,Di,Mi,Do,Fr,Sa,So",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM": "Ja, deaktivieren",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE": "@-Erwähnung deaktivieren?",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT": "Dein Name wird hier dann nicht mehr mit Deinem Profil verlinkt.",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES": "Ein Unternehmen",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS": "Ein Event",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS": "Eine Gruppe",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS": "Einen Job",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS": "Eine Person",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS": "Einen Artikel",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS": "Ein Thema",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS": "Entdecke {keyword}-Jobs.",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT": "{keyword}-Jobs entdecken",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_INCREMENTAL_SEARCH": "Suchvorschläge",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_NAVIGATION_SUGGESTIONS": "Was suchst Du?",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_QUERY_SUGGESTION": "Suchvorschläge",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_INTERACTIONS": "Profile, die Du besucht hast",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_SEARCHES": "Deine letzten Job-Suchen",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECOMMENDATION": "Empfehlungen",
    "DUPLICATE_SHARE_ERROR": "Du hast dies schon geteilt – Dein Netzwerk ist also bestens informiert.",
    "ERROR_SOMETHING_WENT_WRONG": "Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.",
    "FOOTER_LANGUAGES": "Sprache",
    "FRAME_HEADER_UPSELL_PREMIUM": "Premium werden",
    "FRAME_HEADER_UPSELL_PROJOBS": "ProJobs entdecken",
    "FRAME_NAVIGATION_DISCO": "Entdecken",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE": " Was denkst Du über die neue App?",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "Dein Feedback",
    "FRAME_NAVIGATION_JOBS": "Jobs",
    "FRAME_NAVIGATION_ME_HUB": "Deins",
    "FRAME_NAVIGATION_NETWORKING_ICON_TEXT": "Netzwerken",
    "FRAME_NAVIGATION_PROJOBS_UPSELL": "ProJobs werden",
    "FRAME_NAVIGATION_SUPI": "Start",
    "FRAME_NAVIGATION_UPSELL_HEADLINE": "Angebote für Dich",
    "FRAME_NAVIGATION_YOUR_PREMIUM": "Dein Premium",
    "FRAME_NAVIGATION_YOUR_PROJOBS": "Dein ProJobs",
    "HEADER_SKIP_NAVIGATION": "Navigation überspringen",
    "INSIDER_FOLLOWED_BY": "Abonniert von",
    "INSIDER_FOLLOWED_BY_AND": "und",
    "INSIDER_FOLLOWED_BY_AND_MORE": "weiteren",
    "JOB_SEARCH_ALERTS_ALERT_NAME_ALL": "Alle Jobs",
    "LIKERS_LIST_HEADLINE": "Diesen Mitgliedern gefällt das:",
    "LIKE_BUTTON_LABEL": "Gefällt mir",
    "MALT_FILE_UPLOAD_ERROR_MESSAGE": "Die Datei \"{filesTooBig}\" ist leider zu groß: Bis zu {maxSize} MB sind erlaubt.",
    "MALT_FILE_UPLOAD_ERROR_MESSAGE_PLURAL": "Du kannst Dateien von bis zu {maxSize} MB hochladen. Diese Dateien sind daher leider zu groß: {filesTooBig}",
    "MALT_FILE_UPLOAD_NO_FILE": "Noch keine Datei ausgewählt",
    "MALT_FILE_UPLOAD_NUMBER_OF_FILES": "{numberOfFiles} Dateien",
    "MALT_FOOTER_COPYRIGHT_API": "© {siteoperator} | Alle Rechte vorbehalten",
    "MALT_IMAGE_UPLOAD_BROWSE_BUTTON": "Datei auswählen",
    "MALT_TEST_RUBY_STYLE_TRANSLATION": "Mein Name ist {name}.",
    "MESSENGER_SHARE_COMMENT_PLACEHOLDER": "Hier kannst Du Deinen Link kommentieren.",
    "MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL": "Empfänger:",
    "MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER": "Empfänger eingeben",
    "MESSENGER_SHARE_TARGET_LABEL": "Deine Nachricht:",
    "MONTH_NAMES": "Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember",
    "MONTH_NAMES_SHORT": "Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez",
    "MYXING_LOADING_ALERT_MESSAGE": "Das hat leider nicht geklappt. Bitte aktualisiere diese Seite noch einmal.",
    "NBA_BUTTON_CANCEL": "Abbrechen",
    "NBA_BUTTON_CHANGE_IMAGE": "Bild ändern",
    "NBA_BUTTON_CONTINUE": "Weiter",
    "NBA_CREATE_PHOTO_CARD_BENEFIT_TEXT": "Ein gutes Profilbild unterstreicht Dein professionelles Auftreten und erhöht die Anzahl Deiner Profilbesuche.",
    "NBA_CREATE_PHOTO_CARD_GENERIC_ERROR": "Das hat leider nicht geklappt – kannst Du's nochmal versuchen?",
    "NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_MIME_TYPE": "Bitte wähl eines dieser Bildformate: JPG, PNG oder BMP",
    "NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_SIZE": "Bitte wähl ein Bild mit weniger als 20 MB Dateigröße.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MAX": "Max.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MIN": "Min.",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_HEADLINE": "Profilbild",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_SIZES": "Empfohlene Auflösung: 1024 x 1024 px",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_TYPES": "JPG, BMP, PNG (max. 20 MB)",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_CLICK": "Bild hochladen",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_DRAG_N_DROP": "Bild hierhin ziehen",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OR": "oder",
    "NBA_CREATE_PHOTO_CARD_SUCCESS_BENEFIT_TEXT": "Du kannst dieses Bild jederzeit in Deiner Visitenkarte ändern.",
    "NBA_CREATE_PHOTO_CARD_SUCCESS_HEADLINE": "Prima, Du hast nun ein neues Profilbild!",
    "NOTIFICATION_CENTER_LINK": "Mitteilungen",
    "OPTIONS_DELETE": "Ja, bitte löschen.",
    "POLLS_TIME_REMAINING_DAYS_WEB.one": "Endet morgen",
    "POLLS_TIME_REMAINING_DAYS_WEB.other": "Endet in {days} Tagen",
    "POLLS_TIME_REMAINING_DAYS_WEB.zero": "Endet heute",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_BODY": "Schau Dir alle Event-Teilnehmenden direkt in ProBusiness an, verfeinere die Liste mit zahlreichen Filtern und speicher relevante Leads gleich ab.",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_BUTTON": "Teilnahmeliste in ProBusiness ansehen",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_HEADLINE": "Du möchtest Leads aufgabeln?",
    "PROBUSINESS_BANNER_SEARCH_BODY": "Sieh Dir diese Ergebnisse direkt in ProBusiness an, nutz die effizienten Filtermöglichkeiten und speicher gefundene Kontakte gleich als relevante Leads ab.",
    "PROBUSINESS_BANNER_SEARCH_BUTTON": "Ergebnisse in ProBusiness anzeigen",
    "PROBUSINESS_BANNER_SEARCH_HEADLINE": "Vertriebsgeheimnis: Verfeinere Deine Ergebnisse!",
    "PROBUSINESS_DROPDOWN_SHOW_RESULT": "In ProBusiness ansehen",
    "PROBUSINESS_NO_STATUS_AVAILABLE": "Lead-Status derzeit unbekannt",
    "PROBUSINESS_SAVE_AS_LEAD": "Lead merken",
    "PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_HEADLINE": "Ambassador·innen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_TEXT": "Ambassador·innen moderieren die offiziellen XING Gruppen und\norganisieren die offiziellen XING Events. Sie haben dabei einen von drei verschiedenen Schwerpunkten:",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_HEADLINE": "Branchen-Ambassador·innen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_LINK": "Branchen-Gruppen ansehen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_SUB": "Moderator·innen und ausgewiesene Fachleute ihrer Branche",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_TEXT": "Branchen-Ambassador·innen sind\nengagierte XING Mitglieder mit einer spezielle Lizenz im\nRahmen unseres Ambassador-Programms. \nSie moderieren jeweils eine große Branchen-Gruppe, verfügen\nüber Fachwissen und Anerkennung in ihrem Fachgebiet\nund unterstützten die Aktivitäten der Mitglieder ihrer Gruppe\nsowohl online als auch durch offizielle Events.",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_HEADLINE": "Regional-Ambassador·innen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_LINK": "Regional-Gruppen ansehen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_SUB": "Offizieller Event-Veranstalter und Vertrauensperson vor Ort",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_TEXT": "Regional-Ambassador·innen sind Markenbotschafter·innen und regionaler Anlaufpunkt für XING Mitglieder und Interessierte. Sie moderieren jeweils eine offizielle Regional-Gruppe, veranstalten regelmäßig Events in ihrer\nRegion und unterstützen den Austausch der Gruppen-Mitglieder untereinander.",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_HEADLINE": "Themen-Ambassador·innen ",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_LINK": "Themen-Gruppen ansehen",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_SUB": "Expert·innen für Themen rund um die moderne Arbeitswelt",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_TEXT": "Dies sind Spezialisten für die moderne\nArbeitswelt. In ihren Gruppen begleiten sie Diskussionen rund\num das Thema \"Arbeit der Zukunft\". Sie organisieren\nVeranstaltungen, in denen es um neue Trends, Erkenntnisse\nund Meinungen zur Arbeitswelt von heute und morgen geht.",
    "PROFILE_BADGES_LAYER_MODERATOR_SUB": "Ansprechperson und Konfliktlöser einer Gruppe",
    "PROFILE_BADGES_LAYER_PREMIUM_LINK": "Alle Premium-Vorteile im Überblick",
    "PROFILE_BADGES_LAYER_PREMIUM_SUB": "Hilfreiche Zusatzfunktionen für Beruf, Karriere und Geschäft",
    "PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR": "Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR_TEXT": "Was ist ein Ambassador?",
    "PROFILE_BUSINESS_CARD_BADGE_BASIC": "Basis",
    "PROFILE_BUSINESS_CARD_BADGE_BASIC_TOOLTIP": "Premium kennenlernen",
    "PROFILE_BUSINESS_CARD_BADGE_INDUSTRY_AMBASSADOR": "Branchen-Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_MODERATOR": "Moderator",
    "PROFILE_BUSINESS_CARD_BADGE_MODERATOR_TEXT": "Was ist ein Moderator?",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM": "Premium",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TEXT": "Welche Vorteile hat die<br>Premium-Mitgliedschaft?",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TOOLTIP": "Premium-Mitglied",
    "PROFILE_BUSINESS_CARD_BADGE_REGIONAL_AMBASSADOR": "Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_TOPIC_AMBASSADOR": "Themen-Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_XPERT": "Xpert",
    "PROFILE_BUSINESS_CARD_BADGE_XPERT_TEXT": "Was ist ein Xpert?",
    "PROGRESS_BAR_LOADING_PERCENTAGE": "{percentage} % hochgeladen",
    "REMEMBER_PASSWORD": "Eingeloggt bleiben",
    "SEARCH_TOPICS_TAB_SEARCH_BUTTON": "Suchen",
    "SEARCH_TOPICS_TAB_TITLE": "Themen",
    "SE_ALL_VIEW_SEARCH_RESULTS": "{max} Ergebnisse (von {total})",
    "SE_EXTENDED_SEARCH_LIST_DESCRIPTION": "Erweiterte Suche im Bereich ...",
    "SE_FILTER_JOBS_PROJOB_LABEL": "Jobs von Top-Recruitern",
    "SE_JOBS_SUGGESTED_NAME_LOCATION": "Jobs in {location}",
    "SE_LABEL_COMMUNITIES": "Gruppen",
    "SE_LABEL_COMPANIES": "Unternehmen",
    "SE_LABEL_EVENTS": "Events",
    "SE_LABEL_JOBS": "Jobs",
    "SE_LABEL_MEMBERS": "Mitglieder",
    "SE_LABEL_NEWS": "News",
    "SE_OFFICIAL_XING_GROUPS": "Offizielle XING Gruppen",
    "SE_PREMIUM_FLAG_ALTTEXT": "Nur für Premium-Mitglieder",
    "SE_SELECT_MEMBERS": "Mitglieder",
    "SE_SHOW_ALL_RESULTS": "Alle Ergebnisse",
    "SHARERS_BACK_TO_POST_LINK": "Zurück",
    "SHARERS_LIST_BACK_LINK": "Zurück",
    "SHARER_LIST_HEADLINE_MEMBERS": "{total} Mitglieder haben dies geteilt.",
    "SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS": "{total} Mitglieder haben dies geteilt.",
    "SHARER_LIST_HEADLINE_ONE_MEMBER": "Ein Mitglied hat dies geteilt.",
    "SHARER_LIST_ITEM_GO_TO_POST_LINK": "Beitrag ansehen",
    "SHARER_LIST_POST_NOTIFICATION": "Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.",
    "SHARE_ACTIONSHEET_HEADER": "Diesen Beitrag teilen",
    "SHARE_BOX_DEFAULT_ERROR_MESSAGE": "Das hat leider nicht geklappt. Bitte versuch es noch einmal.",
    "SHARE_BOX_HEADER": "Auf XING teilen",
    "SHARE_BOX_PLACEHOLDER": "Hier kannst Du Deinen Link kommentieren.",
    "SHARE_BOX_SHARE_SUCCESS": "Vielen Dank fürs Teilen!",
    "SHARE_BOX_SUBMIT_SHARE": "Teilen",
    "SHARE_BUTTON_LABEL": "Teilen",
    "SHARE_CANCEL_BUTTON": "Abbrechen",
    "SHARE_CHAT_CONTACTS": "Kontakt auswählen",
    "SHARE_CHAT_HINT": "Die Empfänger erhalten einzelne Nachrichten.",
    "SHARE_COUNTER_LABEL": "{counter, plural,\n    =1 {Einmal geteilt}\n    other {#-mal geteilt}\n}",
    "SHARE_FEEDBACK_GROUPS_BUTTON": "Beitrag ansehen",
    "SHARE_FEEDBACK_GROUPS_MESSAGE": "{item} in der Gruppe {group} geteilt",
    "SHARE_FEEDBACK_INSIDERARTICLE_LABEL": "Artikel",
    "SHARE_FEEDBACK_JOB_LABEL": "Job",
    "SHARE_FEEDBACK_KLARTEXT_LABEL": "Beitrag",
    "SHARE_FEEDBACK_LINK_LABEL": "Link",
    "SHARE_FEEDBACK_MESSENGER_BUTTON": "Nachricht ansehen",
    "SHARE_FEEDBACK_MESSENGER_MESSAGE": "{item} per XING Nachricht geteilt",
    "SHARE_FEEDBACK_NEWS_LABEL": "Artikel",
    "SHARE_FEEDBACK_PICTURE_LABEL": "Bild",
    "SHARE_FEEDBACK_POST_LABEL": "Beitrag",
    "SHARE_FEEDBACK_STARTPAGE_BUTTON": "Beitrag ansehen",
    "SHARE_FEEDBACK_STARTPAGE_MESSAGE": "{item} auf der Startseite geteilt",
    "SHARE_FEEDBACK_VIDEO_LABEL": "Video",
    "SHARE_FETCH_ERROR": "Das hat leider nicht geklappt.",
    "SHARE_FETCH_ERROR_COUNTDOWN": "Wir versuchen's in {countdown} Sekunden noch einmal.",
    "SHARE_FETCH_ERROR_RETRY": "Jetzt erneut versuchen",
    "SHARE_MOST_RECENT_CHATS": "Unterhaltungen",
    "SHARE_PREVIEW_ERROR_HEADLINE": "Wir können gerade leider keine Vorschau zeigen.",
    "SHARE_QUICKSHARE_TO_STARTPAGE": "Direkt auf der Startseite",
    "SHARE_TEXT_BOX_LENGTH_ERROR": "{delta, plural, \none {Bitte gib ein Zeichen weniger ein.} \nother {Bitte gib # Zeichen weniger ein.}\n}",
    "SHARE_TO_GROUPS": "In einer Gruppe",
    "SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS": "Forum",
    "SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS": "Gruppe",
    "SHARE_TO_GROUPS_SELECTION_LABEL": "Gruppe auswählen:",
    "SHARE_TO_GROUPS_TEXT_PLACEHOLDER": "Hier kannst Du Deinen Link kommentieren.",
    "SHARE_TO_GROUPS_THREAD_LABEL": "Dein Gruppen-Beitrag:",
    "SHARE_TO_GROUPS_TITLE_PLACEHOLDER": "Beitragstitel",
    "SHARE_TO_MESSENGER": "Als private Nachricht",
    "SHARE_TO_MESSENGER_EMPTY_STATE": "Wir haben leider keinen \"{query}\" gefunden.",
    "SHARE_TO_STARTPAGE": "Mit Anmerkung auf der Startseite",
    "SHARE_USER_SUBTEXT_GROUPS": "In einer Gruppe teilen",
    "SHARE_USER_SUBTEXT_MESSAGE": "Als private Nachricht teilen",
    "SHARE_USER_SUBTEXT_STARTPAGE": "Auf der Startseite teilen",
    "SOCIAL_ADD_CONTACT": "Kontakt-Anfrage schicken",
    "SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION": "Das zeigt Dir ab sofort immer der Zähler neben dem Augen-Symbol.",
    "SOCIAL_BAR_VIEW_COUNTER_HEADING": "Wie oft wurde Dein Beitrag auf XING gesehen?",
    "SOCIAL_BAR_VIEW_COUNTER_SEEN": "Dieser Beitrag von Dir wurde z. B. schon <strong>{views}-mal</strong> gesehen.",
    "SOCIAL_BAR_VIEW_COUNTER_TIP": "<strong>Tipp:</strong> Mit ein paar Kniffen kannst Du <a>Deine Sichtbarkeit auf XING erhöhen</a>.",
    "SOCIAL_COMMENTS_COUNTER_LABEL": "{counter, plural,\n    =0 {Kommentier's als erstes:}\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}",
    "SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER": "Etwas schreiben (andere mit \"@\" erwähnen) …",
    "SOCIAL_COMMENTS_CREATE_PLACEHOLDER": "Schreibe einen Kommentar …",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL": "Abbrechen",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM": "Löschen",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT": "Nicht zufrieden mit Deinem Kommentar? Dann kannst Du ihn einfach löschen.",
    "SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE": "Kommentar löschen?",
    "SOCIAL_COMMENTS_DELETE_DIALOG_TEXT": "Dies kann nicht mehr rückgängig gemacht werden.",
    "SOCIAL_COMMENTS_DELETE_MENTION_LABEL": "Nicht erwähnt werden",
    "SOCIAL_COMMENTS_FORM_PLACEHOLDER": "Etwas schreiben ( mit \"@\" erwähnen) …",
    "SOCIAL_COMMENTS_LOAD_MORE": "Weitere Kommentare",
    "SOCIAL_COMMENTS_PREVIOUS_COMMENTS": "Vorherige Kommentare ansehen",
    "SOCIAL_COMMENTS_PREVIOUS_REPLIES": "Vorherige Antworten ansehen",
    "SOCIAL_COMMENTS_REPLY_PLACEHOLDER": "Deine Antwort an {authorName}",
    "SOCIAL_COMMENT_BUTTON_LABEL": "Kommentieren",
    "SOCIAL_COMMENT_COUNTER_LABEL": "{amount} Kommentare",
    "SOCIAL_COMMENT_CREATE_BUTTON_LABEL": "Kommentieren",
    "SOCIAL_COMMENT_DELETED_MESSAGE": "Dieser Kommentar wurde gelöscht.",
    "SOCIAL_COMMENT_DELETE_LABEL": "Kommentar löschen",
    "SOCIAL_COMMENT_EDIT_LABEL": "Kommentar bearbeiten",
    "SOCIAL_COMMENT_ERROR_TOO_LARGE": "Dieser Kommentar ist leider zu lang: Bis zu 20 Tsd. Zeichen sind erlaubt.",
    "SOCIAL_COMMENT_LIST_EMPTY_HEADLINE": "Und was meinst Du dazu?",
    "SOCIAL_COMMENT_LIST_EMPTY_SUBLINE": "Verrate uns Deine Meinung.",
    "SOCIAL_COMMENT_OVERFLOW_ERROR": "{amount} Zeichen",
    "SOCIAL_COMMENT_REPORT_LABEL": "Kommentar melden",
    "SOCIAL_COMMENT_WAS_EDITED": "Bearbeitet",
    "SOCIAL_GENERIC_REPORT": "Melden",
    "SOCIAL_LIKERS_LIST_HEADLINE": "Diesen Mitgliedern gefällt das:",
    "SOCIAL_LIKERS_LIST_POST_NOTIFICATION": "Du kannst hier nicht alle \"Gefällt mir\"-Angaben sehen, weil einige Mitglieder das in ihren Privatsphäre-Einstellungen so festgelegt haben.",
    "SOCIAL_PMBX_COMMENT_CONTENT_URL": "Inhalt",
    "SOCIAL_PMBX_COMMENT_DATE": "Datum",
    "SOCIAL_PMBX_COMMENT_HEADING": "Deine Kommentare und Antworten",
    "SOCIAL_PMBX_COMMENT_MESSAGE": "Dein Kommentar",
    "SOCIAL_PMBX_COMMENT_ORIGIN": "Wo hast Du kommentiert?",
    "SOCIAL_PMBX_COMMENT_TITLE": "Deine Kommentare und Antworten",
    "SOCIAL_PMBX_COMMENT_USER_AGENT": "System-Info",
    "SOCIAL_PMBX_DESCRIPTION": "Beiträge auf XING, die Du geteilt, kommentiert, erwähnt oder mit \"Gefällt mir\" markiert hast",
    "SOCIAL_PMBX_REACTION_CONTENT_URL": "Inhalt",
    "SOCIAL_PMBX_REACTION_DATE": "Datum",
    "SOCIAL_PMBX_REACTION_LIKE": "Beiträge, die Dir gefallen.",
    "SOCIAL_PMBX_REACTION_ORIGIN": "Wo hast Du auf den Beitrag reagiert?",
    "SOCIAL_PMBX_REACTION_TITLE": "Beiträge, auf die Du reagiert hast",
    "SOCIAL_PMBX_REACTION_USER_AGENT": "User Agent",
    "SOCIAL_PMBX_SHARE_CONTENT_URL": "Inhalt",
    "SOCIAL_PMBX_SHARE_DATE": "Datum",
    "SOCIAL_PMBX_SHARE_GROUPS": "Beiträge, die Du in einer Gruppe geteilt hast",
    "SOCIAL_PMBX_SHARE_MESSAGE": "Deine Anmerkung",
    "SOCIAL_PMBX_SHARE_MESSENGER": "Beiträge, die Du als private Nachricht geteilt hast",
    "SOCIAL_PMBX_SHARE_ORIGIN": "Wo hast Du den Beitrag geteilt?",
    "SOCIAL_PMBX_SHARE_STARTPAGE": "Beiträge, die Du auf der XING Startseite geteilt hast",
    "SOCIAL_PMBX_SHARE_TITLE": "Beiträge, die Du geteilt hast",
    "SOCIAL_PMBX_SHARE_USER_AGENT": "User Agent",
    "SOCIAL_PMBX_TITLE": "Interaktionen",
    "SOCIAL_REPLIES_LOAD_MORE": "Weitere Antworten ansehen",
    "SOCIAL_REPLY_BUTTON": "Antworten",
    "SOCIAL_REPLY_DISCARD_MESSAGE": "Dann kannst Du ihn löschen. Vielleicht schreibst Du ja beim nächsten Mal was.",
    "SOCIAL_REPLY_LOAD_MORE": "Weitere Antwort ansehen",
    "SOCIAL_REPLY_LOAD_MULTIPLE": "Weitere Kommentare ansehen",
    "SOCIAL_REPLY_POST_BUTTON": "Antworten",
    "SOCIAL_SEND_MESSAGE": "Nachricht schreiben",
    "SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS": "Diese Mitglieder haben das geteilt:",
    "SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK": "Beitrag ansehen",
    "SOCIAL_SHARERS_LIST_POST_NOTIFICATION": "Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.",
    "SOCIAL_SHARE_COUNTER_LABEL": "{amount}-mal geteilt",
    "SOCIAL_SHARE_EXTERNAL_LINK_ERROR": "Dieser Link funktioniert leider nicht – deshalb kannst Du ihn nicht teilen.",
    "SOCIAL_SHOW_MORE": "Weiterlesen",
    "SOCIAL_SOCIAL_PROOF_LABEL": "{counter, plural,\n    =1 {gefällt das:}\n    other {# gefällt das:}\n}",
    "SOCIAL_UPDATE_COMMENT_LABEL": "Speichern",
    "TOP_BAR_BACK_BUTTON_ARIA_LABEL": "Zurück",
    "TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM": "Zurück zu {section}",
    "TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE": "Profil",
    "UNIVERSAL_CAREER_LEVEL_LIST": "1. Student·in / Praktikant·in\n2. Berufseinsteiger·in\n3. Mit Berufserfahrung\n4. Manager (mit und ohne Personalverantwortung)\n5. Direktor·in (z. B. Bereichsleitung, VP, SVP)\n6. Geschäftsführer·in (z. B. GF, CEO)",
    "UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST": "1001. Analyse und Statistik\n1002. Administration, Sachbearbeitung und Verwaltung\n1003. Beratung / Consulting\n4. Controlling und Planung\n1004. Customer Service und Kundenbetreuung\n1005. Einkauf, Materialwirtschaft und Logistik\n1006. Finanzen, Rechnungswesen und Controlling\n1007. Forschung, Lehre und Entwicklung\n1008. Gesundheit, Medizin und Soziales\n1009. Grafik, Design und Architektur\n1010. Ingenieurwesen und technische Berufe\n1011. IT und Softwareentwicklung\n1012. Management und Unternehmensentwicklung\n1013. Marketing und Werbung\n1014. Personalwesen und HR\n1015. PR, Öffentlichkeitsarbeit und Journalismus\n1016. Produktion und Handwerk\n1017. Produktmanagement\n1018. Projektmanagement\n1019. Prozessplanung und Qualitätssicherung\n1020. Recht\n1021. Vertrieb und Handel\n1022. Sonstige Tätigkeitsfelder",
    "UPLOADER_ADD_IMAGE": "Bild hinzufügen",
    "UPLOADER_ADD_VIDEO": "Video hinzufügen",
    "UPLOADER_CANCEL_UPLOAD": "Doch nicht hochladen",
    "UPLOADER_ERROR_BODY": "Können Sie es bitte nochmal versuchen?",
    "UPLOADER_ERROR_HEADLINE": "Das hat leider nicht geklappt.",
    "UPLOADER_IMAGE_LOADING_HEADLINE": "Dein Bild wird hochgeladen ...",
    "UPLOADER_TRY_AGAIN": "Noch einmal versuchen",
    "UPLOADER_VIDEO_LOADED_BODY": "Wir bereiten es nun auf, damit es in bestmöglicher Qualität abgespielt werden kann. Sie können es aber gerne schon veröffentlichen oder teilen.",
    "UPLOADER_VIDEO_LOADED_HEADLINE": "Ihr Video wurde hochgeladen.",
    "UPLOADER_VIDEO_LOADING_HEADLINE": "Video wird hochgeladen ...",
    "USER_FLAG_BUTTON_ARIA_LABEL": "Markierung für XING {type}",
    "USER_FLAG_ERROR": "Diese Info können wir gerade leider nicht zeigen.<br>\nVersuch's bitte später nochmal.",
    "USER_FLAG_ERROR_PARAGRAPH_1": "Diese Info können wir gerade leider nicht zeigen.",
    "USER_FLAG_ERROR_PARAGRAPH_2": "Versuch's bitte später nochmal.",
    "USER_FLAG_LOADING": "Einen Moment bitte ...",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS": "Business-Lösungen",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT": "Business",
    "VERTICAL_NAVIGATION_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_COMMUNITIES": "Gruppen",
    "VERTICAL_NAVIGATION_COMPANIES": "Unternehmen",
    "VERTICAL_NAVIGATION_CONTACTS": "Dein Netzwerk",
    "VERTICAL_NAVIGATION_CONTACTS_SHORT": "Netzwerk",
    "VERTICAL_NAVIGATION_CONTENT_PAGES": "News",
    "VERTICAL_NAVIGATION_EVENTS": "Eventmarkt",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "Die neue XING App: Feedback & Hilfe",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT": "Neue App",
    "VERTICAL_NAVIGATION_FOOTER_ADVERTISE": "Werben auf XING",
    "VERTICAL_NAVIGATION_FOOTER_AMIANDO": "Ticketing und Eventvermarktung",
    "VERTICAL_NAVIGATION_FOOTER_ANDROID": "Android",
    "VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN": "Anschreiben-Editor",
    "VERTICAL_NAVIGATION_FOOTER_APPS": "Apps",
    "VERTICAL_NAVIGATION_FOOTER_APP_GALLERY": "Mobile & Desktop Apps",
    "VERTICAL_NAVIGATION_FOOTER_BEWERBUNG": "Bewerbungsratgeber",
    "VERTICAL_NAVIGATION_FOOTER_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_FOOTER_CAREER": "Karriere",
    "VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE": "Karriere-Ratgeber",
    "VERTICAL_NAVIGATION_FOOTER_COACHES": "Coaches + Trainer",
    "VERTICAL_NAVIGATION_FOOTER_COMMUNITY": "Community",
    "VERTICAL_NAVIGATION_FOOTER_COMPANIES": "Unternehmen",
    "VERTICAL_NAVIGATION_FOOTER_COMPANY": "Unternehmen",
    "VERTICAL_NAVIGATION_FOOTER_DEVBLOG": "Devblog",
    "VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL": "Entwickler",
    "VERTICAL_NAVIGATION_FOOTER_DOWNLOAD": "Downloads",
    "VERTICAL_NAVIGATION_FOOTER_EVENTS": "Events",
    "VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH": "Gehaltsvergleich",
    "VERTICAL_NAVIGATION_FOOTER_GROUPS": "Gruppen",
    "VERTICAL_NAVIGATION_FOOTER_HELP": "Hilfe & Kontakt",
    "VERTICAL_NAVIGATION_FOOTER_IMPRINT": "Impressum",
    "VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS": "Investor Relations",
    "VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD": "iPhone & iPad",
    "VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY": "Jobs Verzeichnis",
    "VERTICAL_NAVIGATION_FOOTER_JOB_MARKET": "Jobs",
    "VERTICAL_NAVIGATION_FOOTER_KUNUNU": "Arbeitgeber-Bewertungen",
    "VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF": "Lebenslauf-Editor",
    "VERTICAL_NAVIGATION_FOOTER_LOGINWXING": "Button \"Mit XING einloggen\"",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS": "Mitgliedschaften",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION": "Mitgliedschaft kündigen",
    "VERTICAL_NAVIGATION_FOOTER_MOBILE": "XING Apps",
    "VERTICAL_NAVIGATION_FOOTER_NEWWORKSE": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY": "Mitgliederverzeichnis",
    "VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE": "Praktikum-Guide",
    "VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_FOOTER_PRESS": "Presse",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY": "Datenschutz bei XING",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY": "Datenschutzerklärung",
    "VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_FOOTER_RESOURCES": "Ressourcen",
    "VERTICAL_NAVIGATION_FOOTER_SERVICES": "Weitere Angebote",
    "VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER": "Personalgewinnung mit XING",
    "VERTICAL_NAVIGATION_FOOTER_TANDC": "AGB",
    "VERTICAL_NAVIGATION_FOOTER_TRACKING": "Tracking",
    "VERTICAL_NAVIGATION_FOOTER_WINDOWS_10": "Windows 10",
    "VERTICAL_NAVIGATION_FOOTER_XAS": "Werbeanzeige erstellen",
    "VERTICAL_NAVIGATION_FOOTER_XING_AG": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_XING_NEWS": "XING News",
    "VERTICAL_NAVIGATION_FOOTER_XING_SHARE": "Button \"Auf XING teilen\"",
    "VERTICAL_NAVIGATION_FOOTER_YOUR_XING": "Hauptbereiche",
    "VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR": "BrandManager",
    "VERTICAL_NAVIGATION_HEADER_HELP": "Hilfe",
    "VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS": "Stellenanzeigen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS": "AdManager",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE": "Coach-Profil",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES": "Rechnungen & Konten",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT": "Ausloggen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES": "Mitgliedschaften & Rechnungen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS": "ProJobs-Einstellungen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS": "Einstellungen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS": "Alle Ergebnisse",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON": "Suchen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES": "Gruppen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE": "Arbeitgeber",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS": "Events",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS": "Jobs",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS": "Mitglieder",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS": "Branchen-News",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER": "Job, Namen oder Stichwort eingeben",
    "VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN": "LizenzManager",
    "VERTICAL_NAVIGATION_HEADER_XTM": "TalentManager",
    "VERTICAL_NAVIGATION_MESSAGES": "Nachrichten",
    "VERTICAL_NAVIGATION_MORE": "Mehr",
    "VERTICAL_NAVIGATION_MYPROJOBS": "ProJobs",
    "VERTICAL_NAVIGATION_OTHER_SERVICES": "Weitere Services",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS": "Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER": "Premium werden",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT": "Premium",
    "VERTICAL_NAVIGATION_PROBUSINESS": "ProBusiness",
    "VERTICAL_NAVIGATION_PROJOBS_BENEFITS_FOR_BASIC_USER": "ProJobs werden",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL": "ProJobs entdecken",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT": "ProJobs",
    "VERTICAL_NAVIGATION_STARTPAGE": "Startseite",
    "VIDEOS_AUTOPLAY": "Automatisch abspielen",
    "VIDEOS_SETTINGS": "Videos automatisch abspielen?",
    "VIDEOS_WATCH_VIDEO": "Video ansehen",
    "VIDEO_ENCODING_HEADLINE": "Ihr Video wird gerade aufbereitet.",
    "VIDEO_ENCODING_MESSAGE": "Wir bereiten gerade Dein Video so auf, dass wir es in der bestmöglichen Qualität anzeigen können. Dies kann ein paar Minuten dauern.",
    "VIEW_PAGE_IN_CHINESE": "Diese Seite auf Chinesisch anzeigen",
    "VIEW_PAGE_IN_DUTCH": "Diese Seite auf Niederländisch anzeigen",
    "VIEW_PAGE_IN_ENGLISH": "Diese Seite auf Englisch anzeigen",
    "VIEW_PAGE_IN_FINNISH": "Diese Seite auf Finnisch anzeigen",
    "VIEW_PAGE_IN_FRENCH": "Diese Seite auf Französisch anzeigen",
    "VIEW_PAGE_IN_GERMAN": "Diese Seite auf Deutsch anzeigen",
    "VIEW_PAGE_IN_HUNGARIAN": "Diese Seite auf Ungarisch anzeigen",
    "VIEW_PAGE_IN_ITALIAN": "Diese Seite auf Italienisch anzeigen",
    "VIEW_PAGE_IN_JAPANESE": "Diese Seite auf Japanisch anzeigen",
    "VIEW_PAGE_IN_KOREAN": "Diese Seite auf Koreanisch anzeigen",
    "VIEW_PAGE_IN_POLISH": "Diese Seite auf Polnisch anzeigen",
    "VIEW_PAGE_IN_PORTUGUESE": "Diese Seite auf Portugiesisch anzeigen",
    "VIEW_PAGE_IN_RUSSIAN": "Diese Seite auf Russisch anzeigen",
    "VIEW_PAGE_IN_SPANISH": "Diese Seite auf Spanisch anzeigen",
    "VIEW_PAGE_IN_SWEDISH": "Diese Seite auf Schwedisch anzeigen",
    "VIEW_PAGE_IN_TURKISH": "Diese Seite auf Türkisch anzeigen",
    "XBP_NAVIGATION_ENTRY_LINK": "Business Pages verwalten",
    "XDS_BACK_TO_TOP_BUTTON": "Nach oben",
    "XDS_FLAG_AMBASSADOR_DIVERSE": "Ambassadx",
    "XDS_FLAG_AMBASSADOR_FEMALE": "Ambassadorin",
    "XDS_FLAG_AMBASSADOR_MALE": "Ambassador",
    "XDS_FLAG_AMBASSADOR_NEUTRAL": "Ambassador",
    "XDS_FLAG_BASIC_DIVERSE": "Basis",
    "XDS_FLAG_BASIC_FEMALE": "Basis",
    "XDS_FLAG_BASIC_MALE": "Basis",
    "XDS_FLAG_BASIC_NEUTRAL": "Basis",
    "XDS_FLAG_BETA_DIVERSE": "Beta",
    "XDS_FLAG_BETA_FEMALE": "Beta",
    "XDS_FLAG_BETA_MALE": "Beta",
    "XDS_FLAG_BETA_NEUTRAL": "Beta",
    "XDS_FLAG_INSIDER_DIVERSE": "Insidx",
    "XDS_FLAG_INSIDER_FEMALE": "Insiderin",
    "XDS_FLAG_INSIDER_MALE": "Insider",
    "XDS_FLAG_INSIDER_NEUTRAL": "Insider",
    "XDS_FLAG_MODERATOR_DIVERSE": "Moderatx",
    "XDS_FLAG_MODERATOR_FEMALE": "Moderatorin",
    "XDS_FLAG_MODERATOR_MALE": "Moderator",
    "XDS_FLAG_MODERATOR_NEUTRAL": "Moderator",
    "XDS_FLAG_NEW_DIVERSE": "Neu",
    "XDS_FLAG_NEW_FEMALE": "Neu",
    "XDS_FLAG_NEW_MALE": "Neu",
    "XDS_FLAG_NEW_NEUTRAL": "Neu",
    "XDS_FLAG_PREMIUM_DIVERSE": "Premium",
    "XDS_FLAG_PREMIUM_FEMALE": "Premium",
    "XDS_FLAG_PREMIUM_MALE": "Premium",
    "XDS_FLAG_PREMIUM_NEUTRAL": "Premium",
    "XDS_FLAG_PROBUSINESS_DIVERSE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_FEMALE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_MALE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_NEUTRAL": "ProBusiness",
    "XDS_FLAG_PROCOACH_DIVERSE": "ProCoach",
    "XDS_FLAG_PROCOACH_FEMALE": "ProCoach",
    "XDS_FLAG_PROCOACH_MALE": "ProCoach",
    "XDS_FLAG_PROCOACH_NEUTRAL": "ProCoach",
    "XDS_FLAG_PROJOBS_DIVERSE": "ProJobs",
    "XDS_FLAG_PROJOBS_FEMALE": "ProJobs",
    "XDS_FLAG_PROJOBS_MALE": "ProJobs",
    "XDS_FLAG_PROJOBS_NEUTRAL": "ProJobs",
    "XDS_FLAG_PROTRAINER_DIVERSE": "ProTrainx",
    "XDS_FLAG_PROTRAINER_FEMALE": "ProTrainerin",
    "XDS_FLAG_PROTRAINER_MALE": "ProTrainer",
    "XDS_FLAG_PROTRAINER_NEUTRAL": "ProTrainer",
    "XINGID_ADD_LEAD_SUCCESS": "{displayName} als Lead hinzugefügt",
    "XINGID_REMOVE_LEAD_SUCCESS": "{displayName} als Lead entfernt",
    "XING_FAQ_GUIDE_URL": "https://faq.xing.com/de/dein-netzwerk/netzwerken-so-gehts",
    "XWS_100_APP_PERMISSION_VENDOR_VIDEOS": "Zugriff auf die Video-API für Werbetreibende",
    "XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING": "XING Video-API",
    "X_UI_HEADER_REGISTER": "Registrieren",
    "X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK": "Einloggen",
    "ERROR_REGISTER_EMAIL_MAX_CHANGE": "Du kannst Deine E-Mail-Adresse höchstens 10 mal ändern.",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE": "Über eine Million Jobs",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE": "Profi-Ratgeber für die Job-Suche",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO": "Über 21 Mio. Mitglieder",
    "WELCOME_APP_MINIREG_ERROR_EMAIL": "Überprüfe bitte Deine E-Mail-Adresse.",
    "WELCOME_APP_MINIREG_ERROR_FIRST_NAME": "Gib hier Deinen Vornamen ein.",
    "WELCOME_APP_MINIREG_ERROR_LAST_NAME": "Gib hier Deinen Nachnamen ein.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL": "Zu Deiner Sicherheit solltest Du ein anderes Passwort wählen als Deine E-Mail-Adresse.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME": "Zu Deiner Sicherheit solltest Du ein anderes Passwort wählen als Deinen Nachnamen.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG": "Dein Passwort sollte aus nicht mehr als 1024 Zeichen bestehen ",
    "WELCOME_APP_MINIREG_ERROR_PHONE": "Bitte überprüfe nochmal Deine Telefonnummer.",
    "WELCOME_APP_MINIREG_ERROR_TANDC": "Bitte bestätige die AGB und die Datenschutzbestimmungen.",
    "WELCOME_COMPLETION_HEADLINE": "Willkommen bei XING!",
    "WELCOME_COMPLETION_PAGE_META_TITLE": "Willkommen bei XING! | XING",
    "WELCOME_COMPLETION_SUBLINE": "Für Deine Registrierung fehlen nur noch diese Angaben:",
    "WELCOME_COMPLETION_SUBLINE_B": "Dein Profil haben wir für Dich schon angelegt – jetzt fehlt nur noch Dein Name:",
    "WELCOME_COMPLETION_SUBLINE_C": "Wir zeigen Dir gleich, wen Du bei XING schon kennst. Verrate uns dazu noch Deinen Namen:",
    "WELCOME_COMPLETION_SUBLINE_D": "Trag jetzt noch Deinen Namen ein, damit Kollegen und Freunde Dich wiedererkennen können:",
    "WELCOME_COMPLETION_SUBLINE_E": "Wir sind Dein Begleiter im Beruf – und wer bist Du?",
    "WELCOME_CONFIRMATION_DEFAULT_BOUNCED_BODY": "Bitte schau nochmal, ob Deine E-Mail Adresse so stimmt. Alles korrekt?  Dann {link}.",
    "WELCOME_CONFIRMATION_DEFAULT_BOUNCED_CTA": "E-Mail-Adresse korrigieren",
    "WELCOME_CONFIRMATION_DEFAULT_BOUNCED_HEADER": "Die E-Mail an Dich ist leider zurückgekommen.",
    "WELCOME_CONFIRMATION_DEFAULT_BOUNCED_SUPPORT_LINK_TEXT": "schreib uns bitte",
    "WELCOME_CONFIRMATION_DEFAULT_BUTTON": "E-Mail nicht erhalten?",
    "WELCOME_CONFIRMATION_DEFAULT_COPY_1": "Aktiviere jetzt noch Deinen Zugang:",
    "WELCOME_CONFIRMATION_DEFAULT_COPY_1_C": "Wir haben Dir einen Link an {email} geschickt.*",
    "WELCOME_CONFIRMATION_DEFAULT_COPY_1_D": "... haben wir einen Bestätigungslink an {email} geschickt. *",
    "WELCOME_CONFIRMATION_DEFAULT_COPY_2": "Den Link dazu haben wir an {email} geschickt. *",
    "WELCOME_CONFIRMATION_DEFAULT_COPY_2_C": "Klick darauf, um Deine E-Mail-Adresse zu bestätigen.",
    "WELCOME_CONFIRMATION_DEFAULT_COPY_2_D": "Klick darauf, um Deine Registrierung sicher abzuschließen.",
    "WELCOME_CONFIRMATION_DEFAULT_HEADLINE": "Fast geschafft!",
    "WELCOME_CONFIRMATION_DEFAULT_HEADLINE_C": "Du hast Post:",
    "WELCOME_CONFIRMATION_DEFAULT_HEADLINE_D": "Zu Deiner Sicherheit ...",
    "WELCOME_CONFIRMATION_DEFAULT_SUFFIX": "* Nichts zu sehen? Schau auch in den Spam-Ordner. Und wenn Du Gmail nutzt: Vielleicht ist die E-Mail unter \"Werbung\" oder \"Soziale Netzwerke\" gelandet.",
    "WELCOME_CONFIRMATION_EDIT_EMAIL_BUTTON": "Neuen Aktivierungslink senden",
    "WELCOME_CONFIRMATION_EDIT_EMAIL_COPY": "Wenn nicht, kannst Du sie hier korrigieren:",
    "WELCOME_CONFIRMATION_EDIT_EMAIL_HEADLINE": "Stimmt Deine E-Mail-Adresse?",
    "WELCOME_CONFIRMATION_EDIT_EMAIL_LABEL": "E-Mail",
    "WELCOME_CONFIRMATION_EDIT_EMAIL_REQUEST_ERROR": "Leider ist etwas schief gelaufen. Bitte versuch's nochmal.",
    "WELCOME_CONFIRMATION_EMAIL_RESENT_BUTTON": "E-Mail wieder nicht erhalten?",
    "WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_1": "Wir haben Dir einen neuen Aktivierungslink geschickt, an: {email}",
    "WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_2": "Schließ jetzt die Registrierung ab: per Klick auf den Aktivierungs-Link in Deiner E-Mail.",
    "WELCOME_CONFIRMATION_EMAIL_RESENT_HEADLINE": "Jetzt aber:",
    "WELCOME_CONFIRMATION_PAGE_META_TITLE": "XING Zugang aktivieren | XING",
    "WELCOME_GDPR_IMG_ALT": "Datenschutz bei XING ist im Einklang mit der DSGVO.",
    "WELCOME_INVITATION_HEADLINE": "{firstname} {lastname} lädt Dich ein.",
    "WELCOME_INVITATION_SUBLINE": "Registrier Dich hier, um {firstname} als XING Kontakt zu bestätigen.",
    "WELCOME_LANGUAGE_PAGE_META_TITLE": "Sprache auswählen | XING",
    "WELCOME_LANGUAGE_SELECT_ENGLISH_LABEL": "English",
    "WELCOME_LANGUAGE_SELECT_FRENCH_LABEL": "Français",
    "WELCOME_LANGUAGE_SELECT_GERMAN_LABEL": "Deutsch",
    "WELCOME_LANGUAGE_SELECT_HEADLINE": "In welcher Sprache möchtest Du XING nutzen?",
    "WELCOME_LANGUAGE_SELECT_ITALIAN_LABEL": "Italiano",
    "WELCOME_LANGUAGE_SELECT_SPANISH_LABEL": "Español",
    "WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR": "Gib hier Deine E-Mail-Adresse ein.",
    "WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR": "Gib hier Deinen Vornamen ein.",
    "WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR": "Gib hier Deinen Nachnamen ein.",
    "WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR": "Gib hier Dein Passwort ein.",
    "WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR": "Gib hier Dein Passwort ein.",
    "WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL": "Eingeloggt bleiben",
    "WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR": "Das hat leider nicht geklappt. Versuch's bitte noch einmal.",
    "WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR": "Gib hier Deine E-Mail-Adresse ein.",
    "WELCOME_LOGIN_HEADLINE": "Willkommen zurück!",
    "WELCOME_LOGIN_PASSWORD_LABEL": "Passwort",
    "WELCOME_LOGIN_PROBLEMS_LOGGING_IN": "Probleme beim Einloggen?",
    "WELCOME_LOGIN_SUBMIT_LABEL": "Einloggen",
    "WELCOME_LOGIN_USERNAME_LABEL": "E-Mail",
    "WELCOME_REGISTRATION_CTA_REG_7503_E": "Neues Profil erstellen",
    "WELCOME_REGISTRATION_CTA_REG_7504_A": "Weiter",
    "WELCOME_REGISTRATION_CTA_REG_7504_B": "Registrieren",
    "WELCOME_REGISTRATION_CTA_REG_7504_C": "Jetzt registrieren",
    "WELCOME_REGISTRATION_CTA_REG_7504_D": "Profil erstellen",
    "WELCOME_REGISTRATION_CTA_REG_7504_E": "XING beitreten",
    "WELCOME_REGISTRATION_DATAPROTECTION_LABEL": "Datenschutzerklärung",
    "WELCOME_REGISTRATION_DATAPROTECTION_LINK": "https://privacy.xing.com/de/datenschutzerklaerung",
    "WELCOME_REGISTRATION_EMAIL_LABEL": "E-Mail",
    "WELCOME_REGISTRATION_FIRSTNAME_LABEL": "Vorname",
    "WELCOME_REGISTRATION_HEADLINE": "Hol Dir Dein kostenloses XING Profil:",
    "WELCOME_REGISTRATION_HEADLINE_REG_7088_B": "Jetzt registrieren – gratis und in nur 2 Minuten!",
    "WELCOME_REGISTRATION_HEADLINE_REG_7088_C": "Jetzt registrieren – gratis und in nur 2 Minuten!",
    "WELCOME_REGISTRATION_HEADLINE_REG_7088_D": "Jetzt registrieren – gratis und in nur 2 Minuten!",
    "WELCOME_REGISTRATION_HEADLINE_REG_7088_E": "Jetzt registrieren – gratis und in nur 2 Minuten!",
    "WELCOME_REGISTRATION_HEADLINE_REG_7396_B": "Registrier Dich hier mit nur wenigen Klicks:",
    "WELCOME_REGISTRATION_HEADLINE_REG_7396_C": "Mach jetzt mehr aus Deinem Beruf:",
    "WELCOME_REGISTRATION_HEADLINE_REG_7396_D": "Hol Dir Dein kostenloses XING Profil:",
    "WELCOME_REGISTRATION_HEADLINE_REG_7550_CMP": "Meld Dich jetzt an und nutz Premium 30 Tage gratis:",
    "WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL": "Ja, {email} ist meine korrekte E-Mail-Adresse.",
    "WELCOME_REGISTRATION_LASTNAME_LABEL": "Nachname",
    "WELCOME_REGISTRATION_PASSWORD_LABEL": "Passwort",
    "WELCOME_REGISTRATION_RECAPTCHA_HEADLINE": "Fast geschafft!",
    "WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH": "Um Dich und andere vor Spam zu schützen, möchten wir sichergehen, dass Du eine echte Person bist.",
    "WELCOME_REGISTRATION_SOFT_EMAIL_ERROR": "Prüf bitte nochmal, ob Deine E-Mail-Adresse wirklich korrekt ist.",
    "WELCOME_REGISTRATION_SUBMIT_LABEL": "Weiter",
    "WELCOME_REGISTRATION_TANDC_DESCRIPTION": "Ich akzeptiere die {tandc} und habe die {dataprotection} zur Kenntnis genommen.",
    "WELCOME_REGISTRATION_TANDC_LABEL": "AGB",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON": "Hier klicken und 5 Sekunden lang gedrückt halten",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR": "Das hat leider nicht geklappt – klick mit der Maustaste auf den Button und lass sie 5 Sekunden lang nicht los.",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE": "Und jetzt noch eine Sicherheitsprüfung",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH": "Damit verhindern wir, dass Bots ihr Unwesen auf XING treiben: Klick diesen Button und halte ihn 5 Sekunden lang gedrückt.",
    "WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL": "Die Datei ist entweder zu groß oder im falschen Format. Tipp: PDFs funktionieren am besten und sind in der Regel recht klein.",
    "WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL": "Datei auswählen und hochladen",
    "WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL": "Das hat leider nicht geklappt. Versuch's bitte nochmal.",
    "WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT": "Lade jetzt Deinen Lebenslauf hoch und wir schicken Dir Job-Vorschläge zu.",
    "WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS": "Wir haben Deinen Lebenslauf automatisch mit Deinen Daten befüllt.{br}{br} Bitte schau kurz, ob alles stimmt, und trag die Infos ein, die noch fehlen.",
    "WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL": "Formate: Adobe (PDF), Word (docx) oder Apple (PAGES), max. 100 MB",
    "WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT": "Lass Dich von Recruiter·innen finden",
    "WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS": "Dein Lebenslauf",
    "WELCOME_SEARCHPAGE_CTA": "Entdecke hier Deinen nächsten Job – oder Kollegen und Freunde:",
    "WELCOME_SEARCHPAGE_HEADLINE": "Finde Jobs oder Mitglieder:",
    "WELCOME_SEARCHPAGE_JOBS_BUTTON": "Jobs",
    "WELCOME_SEARCHPAGE_JOBS_PLACEHOLDER": "Job-Titel oder Stichwort eingeben",
    "WELCOME_SEARCHPAGE_MEMBERS_BUTTON": "Mitglieder",
    "WELCOME_SEARCHPAGE_MEMBERS_PLACEHOLDER": "Name, Firma oder Suchwort eingeben",
    "WELCOME_SEARCHPAGE_SEARCH_BUTTON": "Suchen",
    "WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR": "Das hat leider nicht geklappt. Bitte versuch's nochmal.\n",
    "WELCOME_SIGNUP_FORM_VALIDATE_RELOAD_ERROR": "Das hat leider nicht geklappt. Aktiviere bitte einmal die Cookies in den Einstellungen Deines Browsers und lade diese Seite dann neu.",
    "WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR": "Das hat leider nicht geklappt. Bitte versuch's noch einmal.",
    "WELCOME_SIGNUP_PAGE_META_TITLE": "Jetzt kostenlos registrieren | XING",
    "WELCOME_SIGNUP_USPS_TITLE": "XING – Das Jobs-Netzwerk",
    "WELCOME_SIGNUP_USP_CONTACTS_COPY": "Lass Dich finden von Arbeitgebern und über 20.000 Recruiter·innen.",
    "WELCOME_SIGNUP_USP_CONTACTS_TITLE": "Persönliche Job-Angebote",
    "WELCOME_SIGNUP_USP_FREE_COPY": "Schon als Basis-Mitglied kannst Du Deine Job-Suche deutlich optimieren.",
    "WELCOME_SIGNUP_USP_FREE_TITLE": "Kostenlos profitieren",
    "WELCOME_SIGNUP_USP_PRESENCE_COPY": "Entdecke mit XING genau den Job, der wirklich zu Dir passt.",
    "WELCOME_SIGNUP_USP_PRESENCE_TITLE": "Über eine Million Jobs",
    "WELCOME_SIGNUP_USP_SECURITY_COPY": "Knüpf neue Kontakte und erhalte Impulse für ein besseres Job-Leben.",
    "WELCOME_SIGNUP_USP_SECURITY_TITLE": "21 Mio. Mitglieder",
    "WELCOME_STARTPAGE_APP_STORE_BADGE_ALT": "Laden im App Store",
    "WELCOME_STARTPAGE_CULTURE_CHECK_BUTTON": "Zum Kultur-Check",
    "WELCOME_STARTPAGE_CULTURE_CHECK_IMG_ALT": "Eine Illustration des Kultur-Checks",
    "WELCOME_STARTPAGE_CULTURE_CHECK_TEXT": "Flache Hierarchien oder klare Vorgaben? Mehr Work oder mehr Life? Faktoren, die Unternehmenskultur beschreiben, gibt es viele – finde mit dem Kultur-Check heraus, wie Deine ganz persönliche Prioliste aussieht. Damit Du beim nächsten Jobwechsel weißt, worauf es Dir ankommt. Probier’s gleich aus:",
    "WELCOME_STARTPAGE_CULTURE_CHECK_TITLE": "Arbeiten, wo Du Dich wohlfühlst.",
    "WELCOME_STARTPAGE_CULTURE_COMPASS_BUTTON": "Zum Kulturkompass",
    "WELCOME_STARTPAGE_CULTURE_COMPASS_IMG_ALT": "Eine Grafik zur Unternehmenskultur mit einer Skala von traditionell bis modern.",
    "WELCOME_STARTPAGE_CULTURE_COMPASS_TEXT": "Hast Du Dich nicht auch schon immer gefragt, wie die Leute im Unternehmen XY so ticken? Mit dem Kulturkompass schaust Du hinter die Kulissen Deines Wunsch-Arbeitgebers. Hier gibt’s viele wichtige Einblicke in Unternehmen, die Dich interessieren. So weißt Du schon vor der Bewerbung, ob es passt.",
    "WELCOME_STARTPAGE_CULTURE_COMPASS_TITLE": "Folge dem Kulturkompass.",
    "WELCOME_STARTPAGE_DOWNLOAD_APP_CTA": "Bereit für die XING App?",
    "WELCOME_STARTPAGE_FORM_TITLE_REG_7371_01": "Registrier Dich dafür gratis – in nur 2 Minuten:",
    "WELCOME_STARTPAGE_FORM_TITLE_REG_7371_02": "Registrier Dich dafür gratis – in nur 2 Minuten:",
    "WELCOME_STARTPAGE_FORM_TITLE_REG_7371_03": "Werd kostenlos Mitglied – in nur 2 Minuten:",
    "WELCOME_STARTPAGE_FORM_TITLE_REG_7371_04": "Registrier Dich dafür gratis – in nur 2 Minuten:",
    "WELCOME_STARTPAGE_GOOGLE_PLAY_BADGE_ALT": "Jetzt bei Google Play",
    "WELCOME_STARTPAGE_HEADER_BUTTON": "Jetzt registrieren",
    "WELCOME_STARTPAGE_HEADER_IMAGE_ALT": "Glückliche Frau, die sich auf einem Stuhl ausstreckt",
    "WELCOME_STARTPAGE_HEADER_SUBTITLE": "Mach Dein XING!",
    "WELCOME_STARTPAGE_HEADER_TITLE": "Zeit, Dich beruflich zu entfalten.",
    "WELCOME_STARTPAGE_JOBSFINDER_CTA_BUTTON": "Direkt registrieren",
    "WELCOME_STARTPAGE_JOBSFINDER_CTA_TEXT": "Wie sich Standort und Branche aufs Gehalt auswirken? Erfährst Du mit XING.",
    "WELCOME_STARTPAGE_JOBSFINDER_IMG_ALT": "Frau, die versucht, in einer unbequemen Position zu arbeiten",
    "WELCOME_STARTPAGE_JOBSFINDER_SUBTITLE": "Nie mehr verbiegen:",
    "WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_CONSULTING": "Beratung",
    "WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_IT": "IT",
    "WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_LOGISTICS": "Logistik",
    "WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MARKETING": "Marketing",
    "WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MORE_JOBS": "Mehr Bereiche",
    "WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_PROJECT_MANAGEMENT": "Projekt-Management",
    "WELCOME_STARTPAGE_JOBSFINDER_TITLE": "Finde den Job, der wirklich zu Dir passt.",
    "WELCOME_STARTPAGE_JOBS_DIRECTORY_NAVIGATION_TITLE": "Jobs von A bis Z",
    "WELCOME_STARTPAGE_JOBS_VERSION_HEADER_BUTTON": "Kostenlos registrieren",
    "WELCOME_STARTPAGE_JOBS_VERSION_HEADER_SUBTITLE": "Oder wir finden ihn für Dich! Probier's aus:",
    "WELCOME_STARTPAGE_JOBS_VERSION_HEADER_TITLE": "Finde den Job,{br}\nder wirklich passt:",
    "WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_DOGS_FRIENDLY": "Hunde willkommen",
    "WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_FLEXIBILITY": "Flexible Arbeitszeiten",
    "WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_PART_TIME": "Teilzeit",
    "WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_REMOTE": "Home-Office",
    "WELCOME_STARTPAGE_JOBS_VERSION_JOB_INPUT_PLACEHOLDER": "Job-Titel oder Stichwort eingeben",
    "WELCOME_STARTPAGE_JOBS_VERSION_LOCATION_INPUT_PLACEHOLDER": "Standort",
    "WELCOME_STARTPAGE_JOBS_VERSION_SEARCH_SUBMIT_BUTTON": "Job finden",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_IMG_ALT": "Zeichnung einer Person und eines Lebenslaufs",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TEXT": "Ob Umzug, veränderte Lebenssituation oder einfach Lust auf was Neues: Bei XING geht's weniger darum, was war oder ist – es geht vor allem darum, wo Du im Job-Leben noch hinwillst. Ganz ohne Dich verbiegen zu müssen.",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TITLE": "Bei XING bist Du mehr als nur Dein Lebenslauf",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_IMG_ALT": "Zeichnung einer Person mit einem Bild, auf dem verschiedene Köpfe zu sehen sind",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TEXT": "Bei XING sind über 20.000 Recruiter·innen nur eine Nachricht weit entfernt. Du triffst auf echte HR-, Branchen- und Arbeitsmarkt-Expert·innen und knüpfst direkten Kontakt zu Personalern und Mitarbeitenden Deines Wunsch-Arbeitgebers. Mach mit und mach Dein XING!",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TITLE": "Wissen, wie's die anderen machen",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_IMG_ALT": "Zeichnung einer Person mit unterschiedlichen berufstypischen Hüten",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TEXT": "Hier findest Du die meisten und besten Stellenangebote und bekommst passende Empfehlung zur richtigen Zeit. Um herauszufinden, was Du wirklich willst. Um Dich weiterzubilden. Um spannende Arbeitgeber zu entdecken, die genau die Unternehmenskultur bieten, die Du liebst.",
    "WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TITLE": "Über eine Million Jobs und alle Möglichkeiten",
    "WELCOME_STARTPAGE_KEY_FEATURES_EVENTS": "1,7 Millionen Events",
    "WELCOME_STARTPAGE_KEY_FEATURES_JOBS": "Über 250.000 Jobs",
    "WELCOME_STARTPAGE_KEY_FEATURES_MEMBERS": "21 Millionen Mitglieder",
    "WELCOME_STARTPAGE_KEY_FEATURES_NEWS": "Täglich neue Branchen-News",
    "WELCOME_STARTPAGE_MAIN_CTA_BUTTON": "Jetzt kostenlos registrieren",
    "WELCOME_STARTPAGE_MAIN_CTA_TEXT": "XING – das größte Jobs-Netzwerk im deutschsprachigen Raum.",
    "WELCOME_STARTPAGE_MAIN_DESCRIPTION": "XING ist der persönliche Begleiter für Dein Job-Leben. Knüpfe berufliche Kontakte und entdecke spannende Jobs und Fach-News.",
    "WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_B": "Find a job to match your lifestyle.",
    "WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_C": "Ein Ort. Viele Menschen, die Dich interessieren. Erfahre das Neueste, teile Deine Ideen und hol Dir Inspiration.",
    "WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_D": "Schau nach, was Deine Kolleginnen und Kollegen gerade machen. Tausch Dich mit den Menschen aus, die das Gleiche antreibt wie Dich.",
    "WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_E": "Ein Ort. Viele Menschen. Teile Deine Ideen, hol Dir Inspiration und erfahre immer das Neueste.",
    "WELCOME_STARTPAGE_MAIN_TITLE": "XING – Ideen für eine neue Arbeitswelt",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_B": "Find the right job for you",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_C": "Stärken bündeln. In Deinem Netzwerk.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_D": "Dein Job-Leben? Ein Gemeinschaftsding.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_E": "Im Job-Leben die Richtigen kennen.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_01": "Besser arbeiten, besser leben: mit dem passenden Job.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_02": "Mach Schluss mit \"Eigentlich ...\" – und finde einen Job, der passt.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_03": "XING – Dein Begleiter im Beruf.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_04": "Besser arbeiten, besser leben: mit dem passenden Job.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7747": "Zeit, Dich zu entfalten.{br}\nMach Dein XING!",
    "WELCOME_STARTPAGE_MEMBER_DIRECTORY_NAVIGATION_TITLE": "Mitglieder von A bis Z",
    "WELCOME_STARTPAGE_META_DESCRIPTION": "XING ist der persönliche Begleiter für Deinen Beruf. Knüpfe berufliche Kontakte, entdecke spannende Jobs und hol Dir wertvolle Tipps für Dein Job-Leben.",
    "WELCOME_STARTPAGE_META_TITLE": "XING – Ideen für eine neue Arbeitswelt",
    "WELCOME_STARTPAGE_META_TITLE_JOB_SEARCH": "XING - Finde den Job, der wirklich zu Dir passt",
    "WELCOME_STARTPAGE_OG_SITENAME": "XING",
    "WELCOME_STARTPAGE_OG_TITLE": "XING – Ideen für eine neue Arbeitswelt",
    "WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON": "Weiter mit Apple",
    "WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON": "Weiter mit Google",
    "WELCOME_STARTPAGE_XINGGUIDE_BUTTON": "Mehr erfahren",
    "WELCOME_STARTPAGE_XINGGUIDE_IMG_ALT": "Eine Nachricht vom XING Guide, der ein Stellenangebot empfiehlt",
    "WELCOME_STARTPAGE_XINGGUIDE_TEXT": "Du bist auf Job-Suche oder hast gerade einen neuen Job gestartet? Dann hilft Dir der Guide mit Tipps, wie Du Dich auf XING noch besser aufstellst: vom Optimieren Deines Profils bis zu Empfehlungen von passenden Kontakten oder Artikeln – je nachdem, was Du gerade brauchst.",
    "WELCOME_STARTPAGE_XINGGUIDE_TITLE": "Dein Begleiter im Job-Leben.",
    "WELCOME_TOGGLE_FORM_BUTTON_LOGIN": "Einloggen",
    "WELCOME_TOGGLE_FORM_BUTTON_REGISTER": "Registrieren",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_0": "Dieses Passwort lässt sich sehr leicht erraten.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_1": "Dieses Passwort lässt sich sehr leicht erraten.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_2": "Dieses Passwort lässt sich recht leicht erraten.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_3": "Füg noch ein paar Zeichen hinzu, zur Sicherheit.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_4": "Ein gutes Passwort – nicht einfach zu knacken.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_5": "Super – viel besser kann man's nicht machen.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_6": "Ein starkes Passwort – Glückwunsch!",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_LESS_THAN": "Bitte nutze mind. 8 Zeichen für Dein Passwort.",
    "ERROR_REGISTER_EMAIL_REG": "Hello again … diese E-Mail-Adresse kennen wir schon. Bist Du schon registriert? Dann logg Dich einfach ein.",
    "ERROR_REGISTER_EMAIL_SECONDARY": "Bitte beachte den Hinweis zu dieser E-Mail-Adresse (siehe unten).",
    "LOGIN_INVALID_PASSWORD": "Diese Zugangsdaten sind leider nicht korrekt ... vielleicht vertippt?",
    "LOGIN_NEW_REGISTER_TEXT": "Noch kein XING Mitglied? Jetzt kostenlos registrieren",
    "LOGIN_OAUTH_INFO_PARAGRAPH": "Bitte logg Dich mit Deinen XING Zugangsdaten ein, um {application} den Zugriff auf Deine bei XING gespeicherten Daten zu erlauben.",
    "WELCOME_APP_MINIREG_DISALLOWED_DOMAIN": "Diese E-Mail-Adresse gibt's nicht ... vielleicht vertippt?",
    "WELCOME_APP_MINIREG_ERROR_BLACKLIST_LICENSE_COMPANY_MATCH": "Möchtest Du Dein Unternehmen bei XING präsentieren? Gern: Du kannst dafür eine <a href=\"https://recruiting.xing.com/e-recruiting-loesungen/employerbranding?sc_o=welcome_signup_error_companies_suggestion\" target=\"_blank\">XING Seite für Dein Unternehmen erstellen</a>.",
    "WELCOME_APP_MINIREG_ERROR_BLACKLIST_LICENSE_MATCH": "Mit diesen Eingaben kannst Du Dich leider nicht registrieren. Hast Du dazu Fragen? <a href=\"https://www.xing.com/support/contact/registration/confirm_registration\">Schreib uns gern.</a>",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_FIRST_NAME": "Zu Deiner Sicherheit solltest Du ein anderes Passwort wählen als Deinen Vornamen.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_SHORT": "Bitte wähle ein Passwort (mind. 8 Zeichen).",
    "WELCOME_REGISTRATION_SECONDARY_EMAIL_ERROR": "Diese E-Mail-Adresse ist bereits bei einem anderen Konto als Kontakt-Adresse hinterlegt. Willst Du Dich wirklich als neues Mitglied registrieren?",
    "WELCOME_REGISTRATION_SKIP_SECONDARY_EMAIL_CHECK": "Ja, ich möchte mich als neues Mitglied mit der E-Mail {email} registrieren.",
    "VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER": "Freelancer verwalten",
    "VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE": "NWX – Neues zur Zukunft der Arbeit",
    "WELCOME_STARTPAGE_MAIN_SUBTITLE_REG_7494": "Für Dein Leben. Für Deinen Job. Für Dein Job-Leben.",
    "WELCOME_STARTPAGE_MAIN_TITLE_REG_7494": "Weil Du’s Dir vorgenommen hast.",
    "WELCOME_STARTPAGE_META_DESCRIPTION_JOB_SEARCH": "✓ Kultur-Check ✓ Arbeitgeber-Bewertungen ✓ e-Learning ✓ Recruiter-Kontakte - Mach Dein XING für mehr Sinn und Zufriedenheit im Job-Leben"
  }
}